import { api } from './apiClient';

/**
 * POST /admin/v1/email-leads/list
 * Body matches admin API: searchtext + pagination (page, pageSize, sort.createdAt).
 */
export const fetchEmailLeadsList = async (
  page = 1,
  pageSize = 20,
  searchtext = ''
) => {
  try {
    const requestBody = {
      searchtext: searchtext || '',
      pagination: {
        page,
        pageSize,
        sort: { createdAt: -1 },
      },
    };

    const response = await api.post('/api/v1/admin/email-leads/list', requestBody);
    return response.data;
  } catch (error) {
    if (error.response) {
      const message =
        error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    }
    if (error.request) {
      throw new Error(
        'Unable to reach the server. Please check your connection and try again.'
      );
    }
    throw new Error(error.message || 'An unexpected error occurred');
  }
};

/**
 * GET /api/v1/getallemailslist
 * Fetches all email leads for a given date range (for download).
 */
export const fetchAllEmailsList = async (startDate, endDate) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await api.get('/api/v1/getallemailslist', { params });
    return response.data;
  } catch (error) {
    if (error.response) {
      const message =
        error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    }
    if (error.request) {
      throw new Error(
        'Unable to reach the server. Please check your connection and try again.'
      );
    }
    throw new Error(error.message || 'An unexpected error occurred');
  }
};
